// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TUq3","buttons":"styles_buttons__3kH2Z"};